import React from "react";

import ClassicLegIcon from "../classic-leg-icon";

import LegIconRenderer from "./leg-icon-renderer";

export default {
  title: "Icons/ClassicLegIcon",
  component: ClassicLegIcon
};

export const ClassicLegIconExamples = () => (
  <LegIconRenderer component={ClassicLegIcon} />
);
